import Vue from 'vue'
import Vuex from 'vuex'
import LightBootstrap from './light-bootstrap-main'
// Plugins
import App from './App.vue'
import store from './store/store.js'
import ModalMixins from './mixins/modals.js'
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'

// router setup
import router from './router/router'

// plugin setup
//Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(Vuex)
NProgress.configure({ showSpinner: false })

// Adding mixins
Vue.mixin({
  methods: {
    ...ModalMixins
  },
  data () {
    return {}
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

